module.exports = __webpack_public_path__ + "static/mo41-5509ae65ffb32105d9ae53cb7dec0051.png";